var _g, _defs, _defs2, _defs3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgFund = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 120,
  height: 96,
  viewBox: "0 0 120 96",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  filter: "url(#fund_svg__filter0_ddi_4438_2933)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M76.5898 50.99C77.5098 51.92 77.5298 53.38 76.6398 54.25C75.7498 55.12 74.2898 55.06 73.3698 54.13L61.6498 42.2C60.7298 41.27 60.7098 39.81 61.5998 38.94C62.4898 38.07 63.9498 38.13 64.8698 39.06L76.5898 50.99ZM87.9198 58.67L70.1298 76.03C67.2898 78.8 62.5998 78.63 59.6798 75.65L32.2498 47.74C29.3198 44.76 29.2498 40.09 32.0798 37.32L49.8698 19.97C52.7098 17.2 57.3998 17.37 60.3198 20.35L87.7498 48.26C90.6798 51.24 90.7498 55.91 87.9198 58.68V58.67ZM68.4198 71.08L37.0098 39.13L35.3998 40.7C34.3398 41.74 34.3598 43.49 35.4598 44.61L62.8898 72.52C63.9898 73.64 65.7498 73.7 66.8098 72.66L68.4198 71.09V71.08ZM84.5398 51.38L57.1098 23.49C56.0098 22.37 54.2498 22.31 53.1898 23.35L44.2998 32.03L75.7098 63.99L84.5998 55.31C85.6598 54.27 85.6398 52.52 84.5398 51.4V51.38Z"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "fund_svg__filter0_ddi_4438_2933",
  x: 0.00390625,
  y: -12.0012,
  width: 119.992,
  height: 120.002,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 2
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 1
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.808333 0 0 0 0 0.49443 0 0 0 0 0.0235764 0 0 0 1 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_4438_2933"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 15
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.8 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "effect1_dropShadow_4438_2933",
  result: "effect2_dropShadow_4438_2933"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect2_dropShadow_4438_2933",
  result: "shape"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 1
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.5
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "arithmetic",
  k2: -1,
  k3: 1
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "shape",
  result: "effect3_innerShadow_4438_2933"
})))), _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "fund_svg__yellow",
  x1: 30.0049,
  y1: 17.9988,
  x2: 85.4583,
  y2: 84.2957,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.15625,
  stopColor: "white"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.265625,
  stopColor: "#FFDD9A"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.3125,
  stopColor: "white"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.46875,
  stopColor: "white"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.515625,
  stopColor: "#FFDD9A"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.604167,
  stopColor: "white"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.875,
  stopColor: "#FFDD9A"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.973958,
  stopColor: "white"
})))), _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "fund_svg__gray",
  x1: 30.0049,
  y1: 17.9988,
  x2: 85.4583,
  y2: 84.2957,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.15625,
  stopColor: "white"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.265625,
  stopColor: "#C4C3DD"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.3125,
  stopColor: "white"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.46875,
  stopColor: "white"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.515625,
  stopColor: "#C4C3DD"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.604167,
  stopColor: "white"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.875,
  stopColor: "#CECEE0"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.973958,
  stopColor: "white"
})))));
export { SvgFund as ReactComponent };
export default __webpack_public_path__ + "assets/icons/fund.011857.svg";